import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilderSectionModel } from '../../models/form-builder-section-model';

@Component({
  selector: 'tf-core-fb-preview-frame',
  templateUrl: './fb-preview-frame.component.html',
  styleUrls: ['./fb-preview-frame.component.css']
})
export class FbCorePreviewFrameComponent {
    @Input()
    data: FormBuilderSectionModel[];

    @Input()
    form: FormGroup;

}
